const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Format as "17 Jun 2026" */
export const formatListedOnDate = (dateString) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return null;

  const day = String(date.getDate()).padStart(2, '0');
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

/** Format as "Listed on 17 Jun 2026" */
export const formatListedOnLabel = (dateString) => {
  const formatted = formatListedOnDate(dateString);
  return formatted ? `Listed on ${formatted}` : 'Listed on Recently';
};
